module.exports = __webpack_public_path__ + "static/media/docsNew.6a752e8d.svg";